const ALLOWED_LEVELS = ["debug", "info", "notice", "warning", "error", "critical", "alert", "emergency"];

export default (ctx, inject) => {
    inject("logger", {
        /**
         * message: any string
         * data: any object
         * level: any ALLOWED_LEVELS
         */
        async send(message, data, level = "error") {
            ctx.$axios.post("/api/log/frontend", {
                message: message,
                level: ALLOWED_LEVELS.includes(level) ? level : "error",
                context: data,
            });
            console.log(`send error message, data, level =>`, { message, data, level });
        },
    });
};
